import styled from 'styled-components';

const MAX_SIZE_MOBILE = 900;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: 'Helvetica Neue', sans-serif;
  @media (max-width: ${MAX_SIZE_MOBILE}px) {
    align-items: flex-start;
  }
`;

export const UserName = styled.p`
  font-size: 14px;
  margin: 0;
  color: black; /* Adicionando o ponto e vírgula */
  line-height: 16px;
`;

export const UserRole = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  color: #0043ce;
`;
